import PerformanceChartContainer from "./PerformanceChartContainer";
import PerformanceChartStore from "./PerformanceChartStore";

export default PerformanceChartStore(PerformanceChartContainer);